


















import Vue, { PropType } from 'vue'
import { getterFunction } from '@/utils/interfaces'
import { debounce } from 'debounce'

export default Vue.extend({
  props: {
    getter: {
      required: true,
      type: Function as PropType<getterFunction>,
    },
    value: [String, Number, Array, Object],
    searchInput: {
      required: false,
      default: '',
      type: String,
    },
    itemText: {
      type: String,
      default: 'name',
    },
    itemValue: {
      type: String,
      default: 'uuid',
    },
  },
  data() {
    return {
      items: [] as unknown[],
      stopNext: false,
      search: this.searchInput,
      loading: false,
    }
  },
  methods: {
    refresh() {
      this.newItems()
    },
    async newItems() {
      try {
        this.loading = true
        const response = await this.getter({ search: this.search })
        this.items = response.data.results
      } finally {
        this.loading = false
      }
    },
    onInput(e: Event) {
      this.stopNext = true
      this.$emit('input', e)
    },
    filter(): void {
      if (this.stopNext) {
        this.stopNext = false
        return
      }
      if (this.search) {
        this.loading = true
        const timeout = setTimeout(() => {
          this.loading = false
        }, 2500)
        this.filterDebounce(this, this.search, timeout)
      }
    },
    stopNextFilter(): void {
      this.stopNext = true
    },
    filterDebounce: debounce(
      async (vm: any, search: string, timeout: NodeJS.Timeout) => {
        const response = await vm.getter({ search: search })
        clearTimeout(timeout)
        vm.loading = false
        vm.items = response.data.results
      },
      200,
    ),
  },
  watch: {
    search() {
      try {
        this.filter()
      } catch (error) {
        console.log(error)
      }
    },
    searchInput(value: string) {
      this.search = value
      this.filter()
    },
  },
  mounted() {
    this.newItems()
  },
})
